var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'database-processing d-flex flex-column align-center justify-center text-center pointer',
        (_vm.isSelected && 'highlight-instance-row') || 'oversize-icon-box',
    ],attrs:{"data-auto":_vm.dataAutoPrefix('card')},on:{"click":_vm.onClick}},[_c('div',[_c('v-icon',{staticClass:"database-type-icon",attrs:{"size":36}},[_vm._v(" "+_vm._s(`$vuetify.icons.${_vm.icon}`)+" ")])],1),_c('div',{staticClass:"mt-1 icon-text",attrs:{"data-auto":_vm.dataAutoPrefix('title')}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }